import {
  AngularFirestore,
  AngularFirestoreDocument,
  AngularFirestoreCollection,
} from 'angularfire2/firestore';
import { Observable } from 'rxjs';

export interface IUser {
  id: string;
  email: string;
  mainProjectId: string;
  projectIds: string[];
}

export class FireStoreUser {
  private userDoc: AngularFirestoreDocument<any>;

  constructor(
    private afs: AngularFirestore,
    private id: string,
  ) {
    this.userDoc = this.afs.doc<any>(`users/${this.id}`);
  }

  get data$(): Observable<IUser> {
    return this.userDoc.valueChanges().map(m => {
      if (!m) { return null; }
      return <IUser>Object.assign({}, { id: this.id}, m);
    });
  }

  get actions$(): Observable<any[]> {
    return this.data$.switchMap(user =>
      this.afs.doc<any>(`projects/${user.mainProjectId}`)
      // TODO: 期間で抽出
      .collection('actions', ref => ref.orderBy('timestamp', 'desc').limit(10000))
      .valueChanges());
  }

  get projects$(): Observable<any> {
    return this.data$.switchMap(user =>
      Observable.zip(
        ...user.projectIds.map(id => this.afs.doc(`projects/${id}`).valueChanges())
      ));
  }

  static add(afs: AngularFirestore, id, data): IUser {
    data = Object.assign(data, {id});
    afs.doc(`users/${id}`).set(data);
    return data;
  }

  static where(afs: AngularFirestore, column, condition, value): Observable<IUser[]> {
    return afs.collection('users', ref => ref.where(column, condition, value))
      .valueChanges().map(m => <IUser[]>m);
  }

  update(data: IUser) {
    this.afs.doc(`users/${this.id}`).update(data);
  }
}



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/shared/firestore/models/user.ts